const mockStats = [
    {
        id: 1,
        label: "Vídeos entregues",
        rawValue: 3000,
        prefix: "+",
        suffix: "",
        caption: "Projetos produzidos com direção, captação e finalização de alto impacto.",
    },
    {
        id: 2,
        label: "Anos de experiência",
        rawValue: 9,
        prefix: "+",
        suffix: "",
        caption: "Vivência prática em produção visual, linguagem e percepção de marca.",
    },
    {
        id: 3,
        label: "Clientes atendidos",
        rawValue: 100,
        prefix: "+",
        suffix: "",
        caption: "Marcas, eventos e projetos que confiaram na nossa leitura criativa.",
    },
    {
        id: 4,
        label: "Views geradas",
        rawValue: 100,
        prefix: "+",
        suffix: " mi",
        caption: "Mais de cem milhões de visualizações acumuladas em nossos trabalhos.",
    },
];

export default mockStats;


// { id: "s2", label: "Anos de estrada", value: "6" },
// { id: "s3", label: "Clientes atendidos", value: "80+" },
// { id: "s4", label: "Produções/mês", value: "15+" },